<template>
    <section class="page settings">
        <h1>Настройки</h1>
        <div class="settings-body">
            <div class="settings-item" v-if="settings">
                <h3>Уведомления</h3>
                <div class="checkboxes">
                    <Checkbox
                        :index="1"
                        :title="notifications.mobile.title"
                        :default="notifications.mobile.default"
                        :name="notifications.mobile.name"
                        :items="notifications.mobile.items"
                        @change="changeSettings"
                    />
                </div>
                <div class="checkboxes">
                    <Checkbox
                        :index="1"
                        :title="'Email уведомления'"
                        :default="getActiveEmail"
                        :name="'all_notifications'"
                        :items="notifications.email"
                        @change="changeGroup"
                    />
                    <div class="checkboxes-group">
                        <Checkbox 
                            v-for="item in notifications.email"
                            :key="item.id"
                            :index="item.id"
                            :title="item.title"
                            :name="item.name"
                            :impossible="item.impossible"
                            :items="notifications.email"
                            :default="item.default"
                            @change="changeSettings"
                        />
                    </div>
                </div>

            </div>
            <div class="settings-item">
                <h3>Изменить пароль</h3>
                <form class="settings-form" @submit.prevent="changePassword">
                    <input class="input" type="password" v-model.trim="password_old" :class="{invalid: pass_wrong}" required placeholder="Введите старый пароль">
                    <input class="input" type="password" v-model.trim="password_new" :class="{invalid: ($v.password_new.$dirty && $v.password_new.required) || ($v.password_new.$dirty && $v.password_new.minLength)}" required placeholder="Введите новый пароль">
                    <!-- <input class="input" type="password" v-model.trim="password_rep" :class="{invalid: !repeatValid}" required placeholder="Повторите новый пароль"> -->
                    <input type="submit" class="button" value="Изменить пароль">
                </form>
            </div>
            <div class="settings-item">
                <h3>Аккаунт</h3>
                <div class="button red" @click="deleting = true">
                    <p>Удалить аккаунт</p>
                </div>
                <Delete v-if="deleting" @close="deleting = false" />
            </div>
        </div>
    </section>
</template>

<script>
import {required, minLength} from 'vuelidate/lib/validators'

export default {
  name: 'Settings',
  data: () => {
      return {
          password_old: null,
          password_new: null,
          password_rep: null,
          pass_wrong: false,
          settings: null,
          deleting: false,
          notifications: {
              mobile: {
                    id: 1,
                    name: 'mobile_push',
                    title: 'Мобильные push уведомления',
                    default: true
              },
              email: [
                {
                    id: 1,
                    name: 'email_messages',
                    title: 'Уведомлять по email о новых сообщениях',
                    default: true
                },
                {
                    id: 2,
                    name: 'email_events',
                    title: 'Уведомлять по email о всех новых ивентах',
                    impossible: 'email_events_sports',
                    default: true
                },
                {
                    id: 3,
                    name: 'email_likes',
                    title: 'Уведомлять по email о лайках',
                    default: true
                },
                {
                    id: 4,
                    name: 'email_comments',
                    title: 'Уведомлять по email о комментариях',
                    default: true
                },
                {
                    id: 5,
                    name: 'email_events_sports',
                    title: 'Уведомлять по email о новых ивентах только по вашим видам спорта',
                    impossible: 'email_events',
                    default: true
                },
            ],
        }
      }
  },
  components: {
      Checkbox: () => import('@/components/UI/Checkbox'),
      Delete: () => import('./components/Delete'),
  },
  validations: {
        password_new: {required, minLength: minLength(6)}
    },
  computed: {
    getChats () {
      return this.$store.getters.getChats
    },
    getUser() {
      let user = this.$store.getters.getAuthUser;
      return user ? user.id : null
    },
    repeatValid() {
        return this.password_new === this.password_rep
    },
    getActiveEmail() {
        return this.notifications.email.find(notification => notification.default) ? true : false
    }
  },
  methods: {
    async changeSettings({name, value, impossible}, group) {
        await this.$store.dispatch('changeSetting', {name, value})
        let main = this.notifications.email.find(not => not.name == name);
        main ? main.default = value : '';
        if (impossible && value == true && !group) {
            await this.$store.dispatch('changeSetting', {name: impossible, value: false});
            let finded = this.notifications.email.find(not => not.name == impossible);
            finded ? finded.default = false : ''
        }
    },
    async changeGroup(group) {
        group.items.forEach(element => {
            element.value = group.value
            this.changeSettings(element, true)
        });
    },
    async changePassword() {
    if (this.$v.$invalid){
        this.$v.$touch()    
        return
    } else {
        const formData = {
            password_old: this.password_old,
            password_new: this.password_new,
            // password_rep: this.password_rep,
            token: localStorage.getItem('token')
        };
        await this.$store.dispatch('changePassword', formData).then((res) => {
            if (res.token) {
                localStorage.setItem('token', res.token)
                this.password_old = null
                this.password_new = null
                this.password_rep = null
                this.$store.dispatch('addNotification', {message: 'Ваш пароль успешно изменен'})
            } else if (res.error) {
                this.$store.dispatch('addError', {message: res.error})
            } else {
                this.$store.dispatch('addError', {message: 'Что-то пошло не так...'})
            }
        })
    }
    },
    setSettings(settings) {
        
        this.notifications.email = this.notifications.email.map(item => {
            let finded = settings[item.name];
            item.default = finded !== undefined 
                ? finded 
                    ? true 
                    : false
                : item.value
            return item 
        })

        let finded = settings[this.notifications.mobile.name];
        this.notifications.mobile.default = finded !== undefined 
            ? finded 
                ? true 
                : false
            : this.notifications.mobile.default
    }
  },
  async mounted() {
      this.settings = await this.$store.dispatch('getSettings');
      this.settings ? this.setSettings(this.settings[0]) : ''
  },
  created() {
        document.title = this.$route.meta.title;
    }
}

</script>
<style lang="stylus">
.settings
    padding 40px 40px
    display flex
    flex-direction column
    padding-bottom 120px
    overflow-y auto
    
    &-body
        margin-top 30px

    &-item
        width 100%
        padding 30px 0
        border-top 1px solid #f0f0f0
        border-bottom 1px solid #f0f0f0
        h3
            font-weight 500
            padding-bottom 20px

    .checkboxes
        margin-bottom 15px
        &:last-child
            margin-bottom 0
        &-group
            padding-left 20px
        .checkbox
            margin-bottom 15px
            &:last-child
                margin-bottom 0
    &-form
        width 100%
        max-width 500px
        display flex
        flex-direction column
        align-items flex-start
        input
            margin 5px 0
            width 100%
            &.button
                border-color #2d2c3a
                background-color #2d2c3a
                color white
                width auto
</style>